import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/images/child_nondata_img.png'


const _withScopeId = n => (_pushScopeId("data-v-1c5dd8d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "common_layout" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { style: {"border":"1px #ebeef5 solid","margin-top":"20px"} }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "table_title_plate center_flex_layout",
  style: {"justify-content":"space-between"}
}, [
  /*#__PURE__*/_createElementVNode("p", {
    class: "common_font",
    style: {"flex":"2","color":"#909399"}
  }, "賬號名"),
  /*#__PURE__*/_createElementVNode("p", {
    class: "common_font",
    style: {"flex":"1","color":"#909399","text-align":"center"}
  }, " 操作 ")
], -1))
const _hoisted_5 = {
  class: "center_flex_layout table_main_plate",
  style: {"justify-content":"space-between"}
}
const _hoisted_6 = {
  class: "common_font",
  style: {"flex":"2"}
}
const _hoisted_7 = {
  class: "center_flex_layout",
  style: {"flex":"1"}
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "center_flex_layout" }
const _hoisted_11 = {
  key: 1,
  class: "center_flex_layout",
  style: {"height":"calc(100vh - 120px)"}
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "center_flex_layout" }, [
  /*#__PURE__*/_createElementVNode("img", {
    style: {"width":"160px","height":"174px"},
    src: _imports_0
  })
], -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "common_font",
  style: {"color":"#909399","margin-top":"20px","text-align":"center"}
}, " 暫無數據 ", -1))
const _hoisted_14 = { class: "center_flex_layout" }

import { reactive, ref, Ref, onMounted, getCurrentInstance } from "vue";
import { get, post } from "../../utils/request";
import { Encrypt } from "../../utils/secret";
import { useRouter } from "vue-router";

export default /*#__PURE__*/_defineComponent({
  __name: 'childManage',
  setup(__props) {

const router = useRouter();
const { proxy }: any = getCurrentInstance();

const listPage = reactive({ value: 1 });
const listSize = reactive({ value: 1000 });
const childListArr = reactive({ value: [] });

onMounted(() => {
  getChildList();
});

const getChildList = () => {
  get(
    `/manager/sub/account/list?page=${listPage.value}&size=${listSize.value}`,
    {}
  )
    .then((res) => {
      // console.log(JSON.stringify(res));
      if (res.code === 1) {
        childListArr.value = res.result.list;
      }
    })
    .catch((error) => {
      console.log(error);
    });
};

const openMessageBox = (data) => {
  proxy
    .$showDialog({
      title: "提示",
      message: "是否删除" + "【" + data.username + "】的账号？删除后将无法恢复",
    })
    .then(() => {
      // on confirm
      deleteItem(data);
    })
    .catch(() => {
      // on cancel
    });
};

const changeItem = (data) => {
  let encryptData = encodeURIComponent(Encrypt(JSON.stringify(data)));

  router.push("/editChildAccount?childData=" + encryptData);
};

const deleteItem = (data) => {
  post(`/manager/sub/account/del?id=${data.id}`, {}, null)
    .then((res) => {
      // console.log(JSON.stringify(res));
      if (res.code === 1) {
        proxy.$toast("删除成功");
        getChildList();
      }
    })
    .catch((error) => {
      console.log(error);
    });
};

const addNewChild = () => {
  router.push("/editChildAccount?childData=");
};

return (_ctx: any,_cache: any) => {
  const _component_TopHeader = _resolveComponent("TopHeader")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_TopHeader, { title: "子賬號管理" }),
    (childListArr.value.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(childListArr.value, (child) => {
              return (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("p", _hoisted_6, _toDisplayString(child.username), 1),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", {
                    class: "common_font",
                    style: {"color":"#409eff"},
                    onClick: ($event: any) => (changeItem(child))
                  }, " 修改 ", 8, _hoisted_8),
                  _createElementVNode("div", {
                    class: "common_font",
                    style: {"color":"#ff7575","margin-left":"16px"},
                    onClick: ($event: any) => (openMessageBox(child))
                  }, " 刪除 ", 8, _hoisted_9)
                ])
              ]))
            }), 256))
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_el_button, {
              type: "primary",
              style: {"width":"134px","margin-top":"60px"},
              size: "large",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (addNewChild()))
            }, {
              default: _withCtx(() => [
                _createTextVNode("添加子賬號")
              ]),
              _: 1
            })
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("div", null, [
            _hoisted_12,
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_el_button, {
                type: "primary",
                style: {"width":"134px","margin-top":"20px"},
                size: "large",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (addNewChild()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("添加子賬號")
                ]),
                _: 1
              })
            ])
          ])
        ]))
  ]))
}
}

})